import React from 'react';
import { Card } from './ui/card';
import { Code2, Laptop, GraduationCap, Target } from 'lucide-react';
import { personalInfo, education } from '../data/mock';

const About = () => {
  const highlights = [
    {
      icon: <GraduationCap className="w-6 h-6" />,
      title: "Education",
      description: "Final Year BCA Student"
    },
    {
      icon: <Code2 className="w-6 h-6" />,
      title: "Focus Areas",
      description: "Web Development & Programming"
    },
    {
      icon: <Laptop className="w-6 h-6" />,
      title: "Interests",
      description: "AI & Cyber security"
    },
    {
      icon: <Target className="w-6 h-6" />,
      title: "Goal",
      description: "Real-world Project Impact"
    }
  ];

  return (
    <section id="about" className="py-24 bg-slate-900">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
              About <span className="text-blue-400">Me</span>
            </h2>
            <div className="w-20 h-1 bg-gradient-to-r from-blue-500 to-cyan-500 mx-auto"></div>
          </div>

          <div className="grid md:grid-cols-2 gap-12 items-center">
            {/* Left: Bio */}
            <div>
              <div className="mb-8">
                <h3 className="text-2xl font-bold text-white mb-4">Hello! I'm {personalInfo.name.split(' ')[0]}</h3>
                <p className="text-gray-300 leading-relaxed mb-4">
                  {personalInfo.bio}
                </p>
                <p className="text-gray-400 leading-relaxed">
                  Currently pursuing my {education.degree} at {education.college}, I'm building a strong foundation in software development and actively seeking opportunities to apply my skills in innovative projects.
                </p>
              </div>

              {/* Education Card */}
              <Card className="bg-slate-800/50 border-slate-700 p-6 backdrop-blur-sm">
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 rounded-lg bg-blue-500/10 flex items-center justify-center flex-shrink-0">
                    <GraduationCap className="w-6 h-6 text-blue-400" />
                  </div>
                  <div>
                    <h4 className="text-lg font-semibold text-white mb-1">{education.degree}</h4>
                    <p className="text-blue-400 mb-1">{education.college}</p>
                    <p className="text-gray-400 text-sm">{education.duration} • {education.location}</p>
                  </div>
                </div>
              </Card>
            </div>

            {/* Right: Highlights */}
            <div>
              <div className="grid grid-cols-2 gap-4">
                {highlights.map((item, index) => (
                  <Card 
                    key={index} 
                    className="bg-slate-800/50 border-slate-700 p-6 backdrop-blur-sm hover:bg-slate-800/70 transition-all duration-300 hover:scale-105 hover:border-blue-500/30"
                  >
                    <div className="w-12 h-12 rounded-lg bg-gradient-to-br from-blue-500/20 to-cyan-500/20 flex items-center justify-center mb-4 text-blue-400">
                      {item.icon}
                    </div>
                    <h4 className="text-white font-semibold mb-2">{item.title}</h4>
                    <p className="text-gray-400 text-sm">{item.description}</p>
                  </Card>
                ))}
              </div>

              {/* Stats */}
              <div className="mt-8 grid grid-cols-3 gap-4">
                <div className="text-center p-4 bg-slate-800/30 rounded-lg border border-slate-700">
                  <div className="text-3xl font-bold text-blue-400 mb-1">8+</div>
                  <div className="text-gray-400 text-sm">Languages</div>
                </div>
                <div className="text-center p-4 bg-slate-800/30 rounded-lg border border-slate-700">
                  <div className="text-3xl font-bold text-cyan-400 mb-1">4+</div>
                  <div className="text-gray-400 text-sm">Projects</div>
                </div>
                <div className="text-center p-4 bg-slate-800/30 rounded-lg border border-slate-700">
                  <div className="text-3xl font-bold text-blue-400 mb-1">7+</div>
                  <div className="text-gray-400 text-sm">Tools</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
